import * as React from "react";

import domainForStory from "./domain-for-story.ts";
import type {Story} from "./queries/stories-query.tsx";

type Props = {
    story: Story;
};

class StoryFocus extends React.Component<Props> {
    render() {
        const story = this.props.story;

        let content;
        if (story.youtube_id) {
            content = (
                <div className="story-focus__video">
                    {/* eslint-disable-next-line jsx-a11y/iframe-has-title -- TODO: Address a11y error */}
                    <iframe
                        width="600"
                        height="338"
                        src={
                            "//www.youtube.com/embed/" +
                            story.youtube_id +
                            "?rel=0"
                        }
                        frameBorder="0"
                        allowFullScreen
                    />
                </div>
            );
        } else {
            content = (
                <div className="story-focus__content">
                    {story.story.split(/\n{2,}/).map((para, i) => (
                        <p key={i}>{para}</p>
                    ))}
                </div>
            );
        }

        const domain = domainForStory(story);
        return (
            <div className="story-focus">
                {content}
                <div className="story-focus__signature">
                    <h3 className={"story-focus__name " + domain}>
                        {story.name}
                    </h3>
                    <div className="story-focus__date">
                        {story.formatted_date}
                    </div>
                </div>
            </div>
        );
    }
}

export default StoryFocus;
